export function FilesToJSON(files) {
  const rootFolderId = 'root'; // ID for the root folder
  const rootFolderName = 'Αρχή'; // Name for the root folder

  const fileMap = {
    [rootFolderId]: {
      id: rootFolderId,
      name: rootFolderName,
      isDir: true,
      childrenIds: [],
      childrenCount: 0,
    },
  };

  const usedIds = new Set([rootFolderId]);

  function generateUniqueId() {
    let id;
    do {
      id = Math.random().toString(36).substr(2, 12);
    } while (usedIds.has(id));
    usedIds.add(id);
    return id;
  }

  if (files && files.length > 0) {
    files.map((item) => {
      const pathParts = item.path.split('/').filter(Boolean);
      let currentFolderId = rootFolderId;

      pathParts.forEach((part) => {
        let folderId;
        const existingFolderId = fileMap[currentFolderId].childrenIds.find(
          (id) => fileMap[id].name === part,
        );

        if (existingFolderId) {
          if (fileMap[existingFolderId].modDate < item.created_at) {
            fileMap[existingFolderId].modDate = item.created_at;
          }
          folderId = existingFolderId;
        } else {
          folderId = generateUniqueId();
          fileMap[folderId] = {
            id: folderId,
            name: part,
            isDir: true,
            ownerId: item.owner_id,
            childrenIds: [],
            color: 'rgb(224, 225, 167)',
            childrenCount: 0,
            parentId: currentFolderId,
            modDate: item.created_at,
          };
          fileMap[currentFolderId].childrenIds.push(folderId);
          fileMap[currentFolderId].childrenCount++;
        }

        currentFolderId = folderId;
      });
      const fileId = generateUniqueId();
      // Add the file
      if (item.interview_id.slice(0, 5) == 'dummy') {
        fileMap[fileId] = {
          id: fileId,
          interview_id: item.id,
          name: item.interview_id,
          isDir: false,
          ownerId: item.owner_id,
          path: item.path,
          parentId: currentFolderId,
          isHidden: true,
          openable: false,
          selectable: false,
          draggable: false,
          droppable: false,
          groups: item.groups ? item.groups : []
        };
        fileMap[currentFolderId].childrenIds.push(fileId);
      } else {
        fileMap[fileId] = {
          id: fileId,
          interview_id: item.id,
          name: item.interview_id,
          transcriptionStatus: item.transcription_status,
          transcribed: !!(item.transcription_status == 'TRANSCRIBED' || item.transcription_status == 'IN_PROGRESS'),
          color: 'rgb(195, 186, 240)',
          isDir: false,
          ownerId: item.owner_id,
          path: item.path,
          parentId: currentFolderId,
          modDate: item.created_at,
          size: item.transcription_status != 'NOT_TRANSCRIBED',
          groups: item.groups ? item.groups : []
          // size: item.transcription_status == 'TRANSCRIBED' ? 0 : item.transcription_status == 'IN_PROGRESS' ? 1 : 2
        };
        fileMap[currentFolderId].childrenIds.push(fileId);
        fileMap[currentFolderId].childrenCount++;
      }
    });
  }
  return { rootFolderId, fileMap };
}
export default FilesToJSON;
